<div class="page gray-font-color font-family">
  <div class="header-navigation-back">
    <mat-icon (click)="onNavigateToAccountSettings()">arrow_back</mat-icon>
    <span class="title">Reset Password</span>
  </div>

  <div class="padding-top-xlg padding-right-md padding-left-md">
    @if (errorMessage) {
      <mat-error  class="error">
        {{ errorMessage }}
      </mat-error>
    }
    <form
      [formGroup]="form"
      #forgotPasswordForm="ngForm"
      class="padding-top-md"
      (ngSubmit)="onSubmit(forgotPasswordForm)"

      >
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Old Password</mat-label>
        <mat-hint align="start">at least 8 characters</mat-hint>
        <input
          matInput
          [type]="hideOldPassword ? 'password' : 'text'"
          formControlName="oldPassword"
          />
        <mat-icon matSuffix (click)="hideOldPassword = !hideOldPassword">{{
          hideOldPassword ? 'visibility' : 'visibility_off'
        }}</mat-icon>
        @if (form.get('oldPassword')?.touched && form.get('oldPassword')?.invalid) {
          <mat-error>
            {{ getOldPasswordErrorMessage() }}
          </mat-error>
        }
      </mat-form-field>
      <br><br>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>New Password</mat-label>
        <mat-hint align="start">at least 8 characters</mat-hint>
        <input
          matInput
          [type]="hideNewPassword ? 'password' : 'text'"
          formControlName="newPassword"
          />
        <mat-icon matSuffix (click)="hideNewPassword = !hideNewPassword">{{
          hideNewPassword ? 'visibility' : 'visibility_off'
        }}</mat-icon>
        @if (form.get('newPassword')?.touched && form.get('newPassword')?.invalid) {
          <mat-error>
            {{ getNewPasswordErrorMessage() }}
          </mat-error>
        }
      </mat-form-field>
      <div class="padding-top-x4">
        <button
          class="full-width margin-bottom"
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="form.pristine || !form.valid || loading"
          >
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
